import React from 'react';
import type { SeedChoice } from '../../types/demo';
interface BridgeArtProps {
  planted: boolean;
  seed: SeedChoice | null;
  label: string;
}
const SEED_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/a710fc4e-f286-4bab-b22a-e484e5830ebd.jpg';
const SPROUT_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/a053c1ed-bdcc-457c-9c18-1057f5a3aa92.jpg';
export function BridgeArt({
  planted,
  label
}: BridgeArtProps) {
  return <div className="relative aspect-[16/9] w-full overflow-hidden bg-[#2e2219]" data-id="element-2" data-mp="2roes9jqjeb74">
      <img src={SEED_IMAGE} alt={planted ? '' : label} aria-hidden={planted} width={1376} height={768} decoding="async" className="absolute inset-0 h-full w-full object-cover" data-id="element-3" data-mp="2mo0xh3dy4xr1" />
      {planted && <img src={SPROUT_IMAGE} alt={label} width={1376} height={768} decoding="async" className="anim-enter absolute inset-0 h-full w-full object-cover" data-id="element-4" data-mp="3ad3c02daaahb" />}
    </div>;
}